import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CreateMatterForm } from '../matter-form/CreateMatterForm';

export const CreateMatterPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = (matterId?: string) => {
    if (matterId) {
      navigate(`/matters/${matterId}`);
    } else {
      navigate('/matters');
    }
  };

  const handleCancel = () => {
    navigate('/matters');
  };

  return (
    <div className="grow p-6">
      <CreateMatterForm onSuccess={handleSuccess} onCancel={handleCancel} />
    </div>
  );
};
